import React, { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import logo from '../assets/images/resources/header-logo.png';

const Subscribe = () => {
  const query = graphql`
    {
      strapiHomePage {
        footer_first_column {
          id
          info
        }
      }
    }
  `;

  const data = useStaticQuery(query);

  const {
    strapiHomePage: { footer_first_column },
  } = data;

  const [mailText, setMailText] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await addToMailchimp(mailText);
      setResult(res);
      setLoading(false);
      console.log(res);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <section className='mailchimp-one'>
      <div className='container'>
        <div className='row'>
          <div
            className='col-lg-7'
          >
            <div className='block-title text-left'>
              <h2 className='block-title__title'>
                Subscribe to Our <span>Newsletter</span> <br /> to Get New Updates.
              </h2>
            </div>

            <form
              onSubmit={handleSubmit}
              className='mailchimp-one__mc-form mc-form'
              data-url='#'
            >
              <label htmlFor='mc-email' className='sr-only'>
                Add email
              </label>
              <input
                type='email'
                id='mc-email'
                className='formInput'
                placeholder='Email address'
                value={mailText}
                onChange={(e) => setMailText(e.target.value)}
                required
              />
              <button type='submit'>
                {loading ? (
                  <i className='fa fa-circle-o-notch fa-spin'></i>
                ) : (
                  <i className='dimon-icon-right-arrow'></i>
                )}
              </button>
            </form>
            <div className='mc-form__response'>
              {result && result.result === 'success' && (
                <h5 className='text-center my-4 text-white'>
                  Successfully registered
                </h5>
              )}
              {result && result.result === 'error' && (
                <h5 className='text-center my-4 text-white'>
                  The email adddress is already registered
                </h5>
              )}
            </div>
          </div>
          <div className='col-lg-2'>
            <div
              className='site-footer__social'
            >
              <a href='https://www.facebook.com/profile.php?id=100070637730707' aria-label='social icon' aria-hidden='true' target="_blank">
                <i className='fa fa-facebook-square'></i>
              </a>
              <a href='https://twitter.com/Cloud_launch?s=08' aria-label='social icon' aria-hidden='true' target="_blank">
                <i className='fa fa-twitter'></i>
              </a>
              <a href='https://www.instagram.com/cloudlaunch/?hl=en-gb' aria-label='social icon' aria-hidden='true' target="_blank">
                <i className='fa fa-instagram'></i>
              </a>
              <a href='https://www.youtube.com/channel/UCPCLFfD_T_jK5RfHgzCUO7Q' aria-label='social icon' aria-hidden='true' target="_blank">
                <i className='fa fa-youtube'></i>
              </a>
            </div>
          </div>
          <div className='col-lg-3'>
            <div className='footer-widget footer-widget__about'>
              <img
                src={logo}
                width='200'
                alt=''
                className='footer-widget__logo'
              />
              {footer_first_column.map((item) => {
                return (
                  <p className='footer-widget__contact' key={item.id}>
                    {item.info}
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Subscribe;
